import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { type GridRenderCellParams } from "@mui/x-data-grid";
import { memo } from "react";

interface GridCellDateTimeProps {
  value?: Date;
  locale?: Intl.LocalesArgument;
  options?: Intl.DateTimeFormatOptions;
}

const GridCellDateTime = memo(function GridCellDateTime(
  props: GridCellDateTimeProps,
) {
  if (props.value === undefined) {
    return null;
  }
  const [datePart, timePart] = props.value
    .toLocaleString(props.locale, {
      timeZone: props.options?.timeZone,
    })
    .split(", ");

  return (
    <Stack flexDirection="column" alignItems="flex-start">
      <Typography variant="body2">{datePart}</Typography>
      {timePart && (
        <Typography variant="caption" color="text.secondary">
          {timePart}
        </Typography>
      )}
    </Stack>
  );
});

export function DateTimeCell(
  params: GridRenderCellParams & GridCellDateTimeProps,
) {
  return (
    <GridCellDateTime
      value={params.value}
      locale={params.locale}
      options={params.options}
    />
  );
}
